module.exports = __webpack_public_path__ + "static/media/mn19.4af215f4.jpeg";